import { create } from 'zustand';

export type TypeFareEstimate = {
  distance: number | undefined;
  duration: number | undefined;
  disclaimerText: string;
  errorText: string;
  fareDetails?: FareDetailType[];
  rideCredits?: FareDetailType[];
  estimatedFare?: string;
  cancellationReason?: string;
  totalFareWithCredits?: string;
  perRiderFareDetails?: PerRiderFareDetails;
};

export type RideOverviewValues = {
  rideId?: number;
  riderCount?: number;
  boosterCount?: number;
  rideInfo?: {
    createdAt?: Date;
    updatedAt?: string;
    status?: string;
    riderServices?: RiderService[];
  } & TypeFareEstimate;
  rideDetails?: RideDetails;
  driverInfo?: Driver;
};

interface RideOverviewStoreState {
  rideOverview: RideOverviewValues;
  rideHistory?: RideHistory[];
  ridersOnRide: RiderForSmartPooling[];
  setRideOverview: (rideOverview: RideOverviewValues) => void;
  setRideHistory: (rideHistory?: RideHistory[]) => void;
  setRidersOnRide: (ridersOnRide: RiderForSmartPooling[]) => void;
  resetRideOverview: () => void;
}

const initialState = {
  rideOverview: {} as RideOverviewValues,
  rideHistory: undefined as RideHistory[] | undefined,
  ridersOnRide: [] as RiderForSmartPooling[],
};

export const useRideOverviewStore = create<RideOverviewStoreState>((set) => ({
  ...initialState,
  setRideOverview: (rideOverview) => set({ rideOverview }),
  setRideHistory: (rideHistory) => set({ rideHistory }),
  setRidersOnRide: (ridersOnRide) => set({ ridersOnRide }),
  resetRideOverview: () => set({ ...initialState }),
}));
